<bfx-text-input
  #textInput
  [bfxTooltip]="data.errorMsg ? data.errorMsg : null"
  tooltipPosition="top"
  tooltipStyleClass="bfx-tooltip-negative-bold"
  [inputLabelText]="note"
  [size]="'sm'"
  pInputText
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  [(ngModel)]="label"
  class="icd__unsupported"
  [disabled]="true"
  [externalState]="data.state"
  type="search"
  autocomplete="off"
>
</bfx-text-input>
